module.exports = __webpack_public_path__ + "media/img/corporate/pac0-5d6e7eaf09408ba27de721b532d6ce07.svg";